export default __webpack_public_path__ + "static/media/timelineGallery.9d38281d.png";